/* Somarelle · La Soirée global behaviours (Dawn add-on) */
(function () {
  // PDP gallery thumbs + option pill selection (visual only; variant logic lives in the section script)
  document.addEventListener('click', function (e) {
    var t = e.target;
    var sz = t.closest('.size');
    if (sz && sz.parentNode) {
      sz.parentNode.querySelectorAll('.size').forEach(function (x) { x.classList.remove('on'); });
      sz.classList.add('on');
    }
    var sw = t.closest('.sw');
    if (sw && sw.parentNode) {
      sw.parentNode.querySelectorAll('.sw').forEach(function (x) { x.classList.remove('on'); });
      sw.classList.add('on');
    }
  });

  /* Scambio della foto sulla scheda prodotto al passaggio del mouse.
   *
   * Da telefono questo scambio era la causa di una foto rotta: il "passaggio del
   * mouse" sul touch non esiste, ma il browser manda comunque mouseenter al tocco.
   * Il tocco pero' e' anche il clic che porta alla pagina prodotto, quindi il
   * download della seconda foto partiva e veniva annullato a meta' dalla
   * navigazione. Tornando indietro il browser ripristina la pagina com'era, con
   * quel src mai arrivato, e al posto della foto compare il segnaposto grigio.
   *
   * Due misure: lo scambio si attiva solo dove un mouse c'e' davvero, e la foto
   * nuova si mette a schermo solo quando e' gia' scaricata, mai prima.
   */
  function bindHover() {
    var conMouse = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    document.querySelectorAll('.pc-im img[data-alt]').forEach(function (im) {
      if (im.dataset.soireeHover) return;
      im.dataset.soireeHover = '1';
      var a = im.getAttribute('data-alt'), b = im.getAttribute('src');
      /* la foto di partenza si annota comunque: serve a rimetterla a posto se la
         pagina torna indietro con lo scambio a meta' */
      if (b) im.setAttribute('data-base', b);
      if (!conMouse) return;
      var pc = im.closest('.pc');
      if (!pc) return;
      var sopra = false, pronta = false;
      var pre = new Image();
      pre.onload = function () { pronta = true; if (sopra) im.src = a; };
      pc.addEventListener('mouseenter', function () {
        sopra = true;
        if (pronta) im.src = a;
        else if (!pre.src) pre.src = a;
      });
      pc.addEventListener('mouseleave', function () { sopra = false; im.src = b; });
    });
  }

  // UGC videos: autoplay muted while visible, sound only when the viewer asks for it
  /* Dieci video nella stessa fila: se partono tutti quelli visibili, un telefono
     li decodifica insieme e lo scorrimento diventa a scatti, che da fuori si
     legge come "la pagina si e' bloccata". Ne suonano al massimo due, i piu'
     centrati; gli altri restano fermi sul poster e ripartono quando tocca a loro. */
  var MAX_IN_ONDA = 2;
  function bindUgc() {
    if (!('IntersectionObserver' in window)) return;
    var visibilita = new Map();
    function spegni(v) {
      if (!v.paused && v.pause) v.pause();
      if (!v.muted) {
        v.muted = true;
        var b = v.parentNode.querySelector('.usnd');
        if (b) b.classList.remove('on');
      }
    }
    function aggiorna() {
      var ordinati = [].slice.call(visibilita.keys())
        .filter(function (v) { return visibilita.get(v) > 0.35; })
        .sort(function (a, b) { return visibilita.get(b) - visibilita.get(a); });
      ordinati.forEach(function (v, i) {
        if (i < MAX_IN_ONDA) { if (v.paused && v.play) v.play().catch(function () {}); }
        else spegni(v);
      });
      visibilita.forEach(function (ratio, v) { if (ratio <= 0.35) spegni(v); });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { visibilita.set(e.target, e.intersectionRatio); });
      aggiorna();
    }, { threshold: [0, 0.25, 0.35, 0.6, 0.9, 1] });
    document.querySelectorAll('.ugc-card video').forEach(function (v) {
      if (v.dataset.soireeIo) return;
      v.dataset.soireeIo = '1';
      v.muted = true;
      io.observe(v);
    });
  }

  // one clip with sound at a time
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.usnd');
    if (!btn) return;
    e.preventDefault();
    var v = btn.parentNode.querySelector('video');
    if (!v) return;
    var turnOn = v.muted;
    document.querySelectorAll('.ugc-card video').forEach(function (o) { o.muted = true; });
    document.querySelectorAll('.usnd').forEach(function (o) {
      o.classList.remove('on');
      o.setAttribute('aria-label', 'Turn sound on');
    });
    if (turnOn) {
      v.muted = false;
      btn.classList.add('on');
      btn.setAttribute('aria-label', 'Turn sound off');
      v.play().catch(function () {});
    }
  });


  // "keep looking" cards: pick a size and add to bag without leaving the page
  document.addEventListener('click', function (e) {
    var sz = e.target.closest('.qc-size');
    if (sz && !sz.disabled) {
      var card = sz.closest('.qc');
      card.querySelectorAll('.qc-size').forEach(function (o) { o.classList.remove('on'); });
      sz.classList.add('on');
      var add = card.querySelector('.qc-add');
      add.dataset.vid = sz.dataset.vid;
      add.disabled = false;
      add.textContent = 'Add to bag';
      add.classList.remove('ok');
      return;
    }
    var btn = e.target.closest('.qc-add');
    if (!btn || btn.disabled) return;
    var id = parseInt(btn.dataset.vid, 10);
    if (!id) return;
    btn.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.textContent = 'Added';
      btn.classList.add('ok');
      var d = document.querySelector('cart-drawer');
      if (d) {
        fetch(window.location.pathname + '?sections=cart-drawer')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (j['cart-drawer']) {
              var tmp = document.createElement('div');
              tmp.innerHTML = j['cart-drawer'];
              var fresh = tmp.querySelector('#CartDrawer');
              if (fresh) document.querySelector('#CartDrawer').innerHTML = fresh.innerHTML;
            }
            d.classList.remove('is-empty');
            if (d.open) d.open();
          }).catch(function () { if (d.open) d.open(); });
      }
      setTimeout(function () { btn.textContent = 'Add to bag'; btn.classList.remove('ok'); }, 2200);
    }).catch(function () { btn.textContent = 'Try again'; });
  });

  // scroll reveal (luxury, respects reduced motion)
  function bindReveal() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.sec-head,.pc,.bc,.svc,.tile,.rev,.ugc-card,.icard,.zone,.upsell,.mech-tx,.cta-tx');
    var fresh = [];
    els.forEach(function (el, i) {
      if (el.dataset.soireeRv) return;
      el.dataset.soireeRv = '1';
      el.classList.add('rv');
      el.style.setProperty('--d', (i % 6) * 70 + 'ms');
      fresh.push(el);
    });
    if (!fresh.length) return;
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    fresh.forEach(function (el) { ro.observe(el); });
  }


  // The hero's second clip only exists on desktop. Loading it from markup would
  // still cost mobile ~3.5MB for something display:none, so its source is
  // attached here and only above the split breakpoint.
  function bindHero2() {
    var v = document.querySelector('.hv2-video');
    if (!v || v.dataset.soireeHero2) return;
    if (!matchMedia('(min-width: 821px)').matches) return;
    v.dataset.soireeHero2 = '1';
    var src = v.getAttribute('data-src');
    if (!src) return;
    var s = document.createElement('source');
    s.src = src;
    s.type = 'video/mp4';
    v.appendChild(s);
    v.preload = 'auto';
    v.load();
    v.play().catch(function () {});
  }
  window.addEventListener('resize', bindHero2);

  function init() { bindHover(); bindUgc(); bindReveal(); bindHero2(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // re-bind after the theme editor re-renders a section
  document.addEventListener('shopify:section:load', init);
})();

/* Galleria della pagina prodotto.
 *
 * Sotto la foto non c'e' piu' la fila di miniature: erano nove francobolli che
 * rubavano altezza per mostrare in piccolo le stesse foto viste grandi. Restano
 * nel documento, nascoste, perche' sono l'elenco da cui questo modulo legge
 * quali foto esistono per il colore scelto.
 *
 * Al loro posto due frecce sull'immagine e una barra a segmenti: dice quante
 * foto ci sono e a che punto si e', senza occupare spazio. Un solo segmento
 * vuol dire una sola foto, e allora frecce e barra spariscono.
 *
 * Il precarico e' la parte che si sente: prima la foto grande partiva al click
 * e restava bianca per un paio di secondi. Ora arriva mentre si legge la scheda,
 * e quella accanto viene chiesta subito dopo ogni cambio.
 */
(function () {
  var gal = document.querySelector('.gal');
  if (!gal) return;
  var main = gal.querySelector('.gal-main img');
  var bar = gal.querySelector('[data-gal-bar]');
  var thumbs = [].slice.call(gal.querySelectorAll('.gal-thumbs img[data-full]'));
  var navs = [].slice.call(gal.querySelectorAll('.gal-nav'));
  if (!main || !thumbs.length) return;

  var warmed = {};
  function warm(src) {
    if (!src || warmed[src]) return;
    warmed[src] = true;
    var i = new Image();
    if ('fetchPriority' in i) i.fetchPriority = 'low';
    i.decoding = 'async';
    i.src = src;
  }

  /* Le foto del colore non scelto vengono nascoste dallo script della sezione:
     visibile qui vuol dire "appartiene al colore a schermo". */
  function live() {
    return thumbs.filter(function (t) { return t.style.display !== 'none'; });
  }
  function at(list) {
    for (var i = 0; i < list.length; i++) if (list[i].classList.contains('on')) return i;
    return 0;
  }

  function show(t) {
    if (!t || !t.dataset.full) return;
    var src = t.dataset.full;
    thumbs.forEach(function (x) { x.classList.remove('on'); });
    t.classList.add('on');
    paint();
    var next = new Image();
    next.onload = next.onerror = function () {
      main.src = src;
      main.classList.remove('is-loading');
    };
    next.src = src;
    if (next.complete) { main.src = src; main.classList.remove('is-loading'); }
    else main.classList.add('is-loading');
    var l = live(), i = at(l);
    warm((l[i + 1] || l[0] || {}).dataset && (l[i + 1] || l[0]).dataset.full);
    warm((l[i - 1] || l[l.length - 1] || {}).dataset && (l[i - 1] || l[l.length - 1]).dataset.full);
  }

  function go(step) {
    var l = live();
    if (l.length < 2) return;
    show(l[(at(l) + step + l.length) % l.length]);
  }

  /* La barra si ricostruisce a ogni cambio colore, perche' il numero di foto
     cambia con il colore: cinque per il nero, quattro per il crema. */
  function paint() {
    var l = live();
    if (bar) {
      if (bar.childNodes.length !== l.length) {
        bar.innerHTML = '';
        l.forEach(function () { bar.appendChild(document.createElement('i')); });
      }
      var i = at(l);
      [].forEach.call(bar.children, function (seg, k) { seg.className = k === i ? 'on' : ''; });
      bar.hidden = l.length < 2;
    }
    navs.forEach(function (b) { b.hidden = l.length < 2; });
  }

  gal.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.gal-nav') : null;
    if (b) { e.preventDefault(); go(b.classList.contains('gal-prev') ? -1 : 1); return; }
    var t = e.target.closest ? e.target.closest('.gal-thumbs img') : null;
    if (t) show(t);
  });
  navs.forEach(function (b) {
    b.addEventListener('mouseenter', function () {
      var l = live();
      var t = l[(at(l) + (b.classList.contains('gal-prev') ? -1 : 1) + l.length) % l.length];
      if (t) warm(t.dataset.full);
    }, { passive: true });
  });

  /* Sul telefono le frecce ci sono ma la mano va di lato: si scorre come su
     qualunque altra galleria. Solo gesti chiaramente orizzontali, altrimenti si
     ruba lo scorrimento verticale della pagina. */
  var x0 = null, y0 = null;
  gal.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { x0 = null; return; }
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  gal.addEventListener('touchend', function (e) {
    if (x0 === null || !e.changedTouches.length) return;
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.6) go(dx < 0 ? 1 : -1);
  }, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (!gal.contains(document.activeElement)) return;
    e.preventDefault();
    go(e.key === 'ArrowRight' ? 1 : -1);
  });

  /* A pagina ferma si scaricano tutte, una alla volta e con priorita' bassa:
     sono foto che il cliente vedra' quasi certamente. */
  var queue = thumbs.map(function (t) { return t.dataset.full; });
  function nextInQueue() {
    var src = queue.shift();
    if (!src) return;
    warm(src);
    setTimeout(nextInQueue, 160);
  }
  if ('requestIdleCallback' in window) requestIdleCallback(nextInQueue, { timeout: 2000 });
  else setTimeout(nextInQueue, 1000);

  window.soireeGal = { sync: paint, go: go };
  paint();
})();

/* Convertitore di valuta.
 *
 * L'app (BUCKS) converte i prezzi una volta sola, quando la pagina si carica: cerca
 * gli `span.money`, si segna l'importo originale e ci riscrive sopra. Tutto quello
 * che il tema ridisegna dopo (prezzo al cambio di taglia, righe del carrello, scheda
 * di aggiunta rapida) nasce in dirham e resterebbe in dirham in mezzo a prezzi
 * convertiti. Questa funzione le dice di rifare il giro.
 *
 * Le chiamate arrivano ravvicinate (una modifica al carrello ne fa partire diverse),
 * quindi si accorpano in un colpo solo alla fine.
 */
(function () {
  var pending = null;
  window.soireeReconvert = function () {
    var b = window.bucksCC;
    if (!b || typeof b.reConvert !== 'function') return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      try { b.reConvert(); } catch (e) { /* l'app non c'e' o e' cambiata: i prezzi restano in dirham */ }
    }, 40);
  };
})();

/* Rete di sicurezza per le foto rotte.
 *
 * Quando si torna indietro con il tasto del browser, la pagina viene ripristinata
 * esattamente com'era, comprese le immagini il cui scaricamento era stato
 * interrotto dalla navigazione: restano rotte, e il browser da solo non riprova.
 * Qui si rimettono le schede alla loro foto di partenza e si richiede una volta
 * ogni immagine che risulta fallita, in tutta la pagina.
 *
 * Non si tocca niente che stia caricando o che sia gia' a posto: si interviene
 * solo dove il browser dichiara di avere finito senza aver ottenuto un pixel.
 */
(function () {
  function rotta(im) {
    return im.complete && im.naturalWidth === 0 && !!(im.currentSrc || im.getAttribute('src'));
  }
  function riprova(im) {
    var s = im.currentSrc || im.getAttribute('src');
    if (!s) return;
    im.removeAttribute('src');
    /* un giro di eventi prima di richiedere: senza, il browser riusa la richiesta fallita */
    setTimeout(function () { im.src = s; }, 0);
  }
  function ripara() {
    document.querySelectorAll('.pc-im img[data-base]').forEach(function (im) {
      var base = im.getAttribute('data-base');
      if (base && im.getAttribute('src') !== base) im.src = base;
    });
    document.querySelectorAll('img').forEach(function (im) {
      if (rotta(im)) riprova(im);
    });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) ripara(); else setTimeout(ripara, 400); });
  window.addEventListener('pagehide', function () {
    /* uscendo dalla pagina si rimette la foto di partenza: cosi' al ritorno la
       scheda e' gia' giusta anche prima che questo codice giri di nuovo */
    document.querySelectorAll('.pc-im img[data-base]').forEach(function (im) {
      var base = im.getAttribute('data-base');
      if (base && im.getAttribute('src') !== base) im.src = base;
    });
  });
  /* una foto puo' fallire anche senza tornare indietro: un tentativo solo, poi basta */
  document.addEventListener('error', function (e) {
    var im = e.target;
    if (!im || im.tagName !== 'IMG' || im.dataset.soireeRetry) return;
    im.dataset.soireeRetry = '1';
    setTimeout(function () { riprova(im); }, 300);
  }, true);
})();

/* Apertura a piu' scene.
 *
 * Cambia da sola ogni tot secondi, si ferma quando il mouse ci sta sopra o
 * quando qualcuno usa i pallini, riparte quando il mouse esce. Sta ferma se la
 * scheda del browser non e' in primo piano, altrimenti al ritorno si trova
 * dieci scene piu' avanti, e sta ferma per chi ha chiesto meno animazioni nelle
 * impostazioni del sistema.
 */
(function () {
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;
  var slides = [].slice.call(hero.querySelectorAll('[data-slide]'));
  if (slides.length < 2) return;
  var dots = [].slice.call(hero.querySelectorAll('[data-hero-dots] button'));
  var lento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var spento = hero.hasAttribute('data-auto-off') || lento;
  var attesa = (parseInt(hero.getAttribute('data-auto'), 10) || 5) * 1000;
  var i = 0, timer = null, fermo = false;

  function vai(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    dots.forEach(function (d, k) {
      d.classList.toggle('on', k === i);
      d.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
  }
  function riparti() {
    clearTimeout(timer);
    if (spento || fermo || document.hidden) return;
    timer = setTimeout(function () { vai(i + 1); riparti(); }, attesa);
  }
  dots.forEach(function (d, k) {
    d.addEventListener('click', function () { vai(k); riparti(); });
  });
  hero.addEventListener('mouseenter', function () { fermo = true; clearTimeout(timer); });
  hero.addEventListener('mouseleave', function () { fermo = false; riparti(); });
  hero.addEventListener('focusin', function () { fermo = true; clearTimeout(timer); });
  hero.addEventListener('focusout', function () { fermo = false; riparti(); });
  document.addEventListener('visibilitychange', riparti);
  riparti();
})();

/* Apertura a piu' scene: cambia da sola, si ferma sotto il mouse, si ferma se
 * la scheda non e' in primo piano, e sta ferma per chi ha chiesto meno
 * animazioni nelle impostazioni del sistema. */
(function () {
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;
  var slides = [].slice.call(hero.querySelectorAll('[data-slide]'));
  if (slides.length < 2) return;
  var dots = [].slice.call(hero.querySelectorAll('[data-hero-dots] button'));
  var lento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var spento = hero.hasAttribute('data-auto-off') || lento;
  var attesa = (parseInt(hero.getAttribute('data-auto'), 10) || 5) * 1000;
  var i = 0, timer = null, fermo = false;

  function vai(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    dots.forEach(function (d, k) {
      d.classList.toggle('on', k === i);
      d.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
  }
  function riparti() {
    clearTimeout(timer);
    if (spento || fermo || document.hidden) return;
    timer = setTimeout(function () { vai(i + 1); riparti(); }, attesa);
  }
  dots.forEach(function (d, k) { d.addEventListener('click', function () { vai(k); riparti(); }); });
  hero.addEventListener('mouseenter', function () { fermo = true; clearTimeout(timer); });
  hero.addEventListener('mouseleave', function () { fermo = false; riparti(); });
  hero.addEventListener('focusin', function () { fermo = true; clearTimeout(timer); });
  hero.addEventListener('focusout', function () { fermo = false; riparti(); });
  document.addEventListener('visibilitychange', riparti);
  riparti();
})();

